import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";

const Toaster = (props) => {
  const {
    show,
    title,
    toastType,
    position,
    autoClose,
    hideProgressBar,
    closeOnClick,
    pauseOnHover,
    draggable,
    progress,
    theme,
    rtl,
    closeButton,
  } = props;

  useEffect(() => {
    if (show) {
      if (toastType === "success") {
        toast.success(title, {
          props,
          onClose: () => {
            closeButton();
          },
        });
      } else if (toastType === "failure") {
        toast.error(title, {
          props,
          onClose: () => {
            closeButton();
          },
        });
      } else if (toastType === "info") {
        toast.info(title, {
          props,
          onClose: () => {
            closeButton();
          },
        });
      } else if (toastType === "warning") {
        toast.warn(title, {
          props,
          onClose: () => {
            closeButton();
          },
        });
      } else {
        toast(title, {
          props,
          onClose: () => {
            closeButton();
          },
        });
      }
    }
  }, [
    autoClose,
    closeOnClick,
    draggable,
    hideProgressBar,
    pauseOnHover,
    position,
    progress,
    show,
    title,
    toastType,
    theme,
    closeButton,
    props,
  ]);

  return (
    <ToastContainer
      position={position || "top-right"}
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={true}
      closeOnClick={true}
      rtl={rtl || false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme={theme || "dark"}
    />
  );
};

export default Toaster;

/**
 * To call the toaster
 * const [show, isSHow] = useState(false);
 * const closeButton = () => {
   isShowToaster(false);
  };
 * <Toaster
        show={show}
        toastType={"success"} // Pass the desired type
        title={"wow so easy"} '' Title to show
        theme={"light"}
        position="top-center"
        closeButton={()=>{}}
      />
 * 
 * 
*/
